import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <div className="error-title">Page Lost in Space</div>
        <div className="error-description">
          The page you're looking for has drifted into the cosmic void.
          <br />
          It might have been sucked into a black hole or traveled to another dimension.
        </div>
        
        <div className="space-elements">
          <div className="floating-asteroid asteroid-1"></div>
          <div className="floating-asteroid asteroid-2"></div>
          <div className="floating-asteroid asteroid-3"></div>
          <div className="shooting-star"></div>
        </div>
        
        <div className="navigation-buttons">
          <Link to="/" className="home-button">
            <span className="button-icon">🚀</span>
            Return to Home
          </Link>
          <button 
            onClick={() => window.history.back()} 
            className="back-button"
          >
            <span className="button-icon">⬅️</span>
            Go Back
          </button>
        </div>
        
        <div className="space-facts">
          <div className="fact">
            <span className="fact-icon">⭐</span>
            <span>Did you know? There are more stars in the universe than grains of sand on Earth.</span>
          </div>
          <div className="fact">
            <span className="fact-icon">🌌</span>
            <span>The universe is expanding faster than the speed of light.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
